import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';

const useNotification = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const { t } = useTranslation();

  function enqueue(message: string, options = {}) {
    const action = (key: any) => (
      <Button
        onClick={() => {
          closeSnackbar(key);
        }}
        color="inherit"
      >
        {t('close')}
      </Button>
    );

    return enqueueSnackbar(message, {
      ...{ action },
      ...options,
    });
  }

  function defaultSnackbar(msg: string, options = {}) {
    enqueue(msg, {
      ...{ variant: 'default' },
      ...options,
    });
  }

  function success(msg: string, options = {}) {
    enqueue(msg, {
      ...{ variant: 'success' },
      ...options,
    });
  }

  function warning(msg: string, options = {}) {
    enqueue(msg, {
      ...{ variant: 'warning' },
      ...options,
    });
  }

  function info(msg: string, options = {}) {
    enqueue(msg, {
      ...{ variant: 'info' },
      ...options,
    });
  }

  function error(msg: string, options = {}) {
    enqueue(msg, {
      ...{
        variant: 'error',
        autoHideDuration: 7000,
      },
      ...options,
    });
  }

  return {
    enqueueSnackbar: enqueue,
    closeSnackbar,
    notification: {
      success,
      warning,
      info,
      error,
      default: defaultSnackbar,
    },
  };
};

export default useNotification;
